import UserFooter from "./UserFooter";

export default UserFooter;
